<template>
  <div>
      <!-- <b-card :title="$t('incident_form_handling_sub_title')">-->
        <b-row>
          <b-col md="3">
            <b-form-group
              :label="$t('systematic_intimidation.protocol_number')"
              label-for="protocol">
              <b-form-input
                id="protocol"
                :value="_.get(requestForm, 'form.protocol_number')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t('systematic_intimidation.created_at')"
              label-for="created_at">
              <b-form-input
                id="created_at"
                :value="_.get(requestForm, 'form.created_date_formatted')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col md="3" class="content-center content-center">
           <NavigationOriginPopup :navigationField="navigationField"/>
          </b-col>
          <b-col md="3" class="content-center content-center">
            <ProtocolQueryHistoryPopup :protocol_number="_.get(requestForm, 'form.protocol_number')" type="systematic-intimidation" />
          </b-col>
        </b-row>
        <b-row md="12">
          <b-col>
            <b-form-group
              :label="$t('systematic_intimidation.institution_unity')"
              label-for="link">
              <b-form-input
                id="link"
                :value="_.get(requestForm, 'form.legal_entity_name')"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row md="12">
          <b-col>
            <b-form-group
              :label="$t('systematic_intimidation.link_profile')"
              label-for="link">
              <b-form-input
                id="link"
                :value="_.get(requestForm, 'form.link')"
                readonly/>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <!-- description -->
            <b-form-group
              :label="$t('systematic_intimidation.description')"
              label-for="description"></b-form-group>
              <b-form-textarea
                id="description"
                :value="_.get(requestForm, 'form.description')"
                rows="4"
                readonly/>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col
            lg="12">
            <h5 class="mt-2 mb-0">{{$t('systematic_intimidation.handling')}}</h5>
            <vs-divider></vs-divider>
          </b-col>
        </b-row>
         <b-row class="m-0">
          <b-col
            lg="4">
              <b-form-group
              :label="$t('systematic_intimidation.status')"
              label-for="status">
              <b-form-input
                id="status"
                :value="_.get(requestForm, 'status_str')"
                readonly/>
              </b-form-group>
          </b-col>
          <b-col lg="8">
            <HandlingHistoryPopup :id="id" :serviceDelegate="services.handling" />
          </b-col>
        </b-row>
  </div>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'

import NavigationOriginPopup from '@/components/popup/NavigationOriginPopup'
import ProtocolQueryHistoryPopup from '@/components/popup/ProtocolQueryHistoryPopup'
import HandlingHistoryPopup from '@/components/popup/HandlingHistoryPopup'

import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip
} from 'bootstrap-vue'

//Services
import SystematicIntimidationFormHandlingService from '@/services/api/intimidation/SystematicIntimidationFormHandlingService'


export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BTable,
    NavigationOriginPopup,
    ProtocolQueryHistoryPopup,
    HandlingHistoryPopup,
  },
  props: {
    id: { //Id handling
      type: Number,
      default: null
    },
    requestForm: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    id: null,
    services: {
      handling: null,
    },
  }),
  methods: {

  },
  watch: {

  },
  computed: {
    navigationField () {
      return _.get(this.requestForm, 'form.navigation_origin.metadata.navigationUser')
    }
  },
  mounted() {
    //Services
    const promisses = []

  },
  beforeMount() {
    //Services
    this.services.handling = SystematicIntimidationFormHandlingService.build(this.$vs)
  }
}
</script>
